import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-313a3527")

_pushScopeId("data-v-313a3527")
const _hoisted_1 = { class: "form-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "m-left-sm" }, "₼", -1)
const _hoisted_3 = { class: "due-date-tip text-color-secondary" }
const _hoisted_4 = { class: "justify-center" }
const _hoisted_5 = { class: "dialog-warning-text" }
const _hoisted_6 = { class: "justify-center" }
const _hoisted_7 = { class: "dialog-warning-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_custom_form_item = _resolveComponent("custom-form-item")
  const _component_decimal_input = _resolveComponent("decimal-input")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_custom_select = _resolveComponent("custom-select")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_select = _resolveComponent("el-select")
  const _component_custom_form = _resolveComponent("custom-form")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_custom_dialog = _resolveComponent("custom-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_custom_form, {
        ref: "formRef",
        rules: _ctx.formRules,
        model: _ctx.formData
      }, {
        default: _withId(() => [
          _createVNode(_component_custom_form_item, {
            label: _ctx.$wordList.CommunalFeeFeature
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.FeatureSwitch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.FeatureSwitch = $event)),
                onChange: _ctx.handleFeatureChange
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    size: "large",
                    style: {"margin-right":"100px"}
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 0,
                    size: "large"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formData.FeatureSwitch !== 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_custom_form_item, {
                  label: _ctx.$wordList.CommunalFeeOfPerSquareMeter,
                  prop: "CommunalFee"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_decimal_input, {
                      modelValue: _ctx.formData.CommunalFee,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.CommunalFee = $event)),
                      class: "width600px"
                    }, {
                      prefix: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_custom_form_item, {
                  label: _ctx.$wordList.DueDate,
                  prop: "DueDate"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_custom_select, {
                      modelValue: _ctx.formData.DueDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.DueDate = $event)),
                      options: _ctx.dueDateOptions,
                      class: "width600px"
                    }, {
                      prefix: _withId(() => [
                        _createVNode(_component_svg_icon, {
                          name: "icon-picker",
                          style: {"margin-top":"6px"},
                          color: "color-warning",
                          fontSize: "17px"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$wordList.CommunalFeeDueDateTip), 1),
                _createVNode(_component_custom_form_item, {
                  label: _ctx.$wordList.AssociatedAccessGroups
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildList, (item) => {
                      return (_openBlock(), _createBlock(_component_custom_form_item, {
                        class: "m-left-sm",
                        key: item.ID,
                        label: `${_ctx.$wordList.DeviceDetailDetailUnitName}：${item.Name}`
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            multiple: "",
                            "multiple-limit": 20,
                            modelValue: item.SelectedAccessGroupID,
                            "onUpdate:modelValue": ($event: any) => (item.SelectedAccessGroupID = $event),
                            placeholder: "Select",
                            class: "width600px"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.AllAccessGroup, (group) => {
                                return (_openBlock(), _createBlock(_component_el_option_group, {
                                  key: group.label,
                                  label: group.label
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.ID,
                                        label: item.Name,
                                        value: item.ID
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rules", "model"]),
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_custom_dialog, {
      modelValue: _ctx.isWarningVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isWarningVisible = $event)),
      title: _ctx.$wordList.TabelDeleteTitle,
      width: "40%"
    }, {
      footer: _withId(() => [
        _createVNode(_component_cus_button, {
          type: "blue",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isWarningVisible = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSure), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$wordList.CommunalFeeFeatureWarningText), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_custom_dialog, {
      modelValue: _ctx.isAllowDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isAllowDialog = $event)),
      title: _ctx.$wordList.TabelDeleteTitle,
      width: "40%"
    }, {
      footer: _withId(() => [
        _createVNode(_component_cus_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.isAllowDialog = false; _ctx.formData.FeatureSwitch = 1})
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_cus_button, {
          class: "m-left-md",
          type: "blue",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isAllowDialog = false))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.Confirm), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$wordList.CommunalFeeFeatureAllowText), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
})